// extracted by mini-css-extract-plugin
module.exports = {"sendCodeBtn":"styles_sendCodeBtn__hRoiA","disabled":"styles_disabled__19Im2"};